var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$store.getters['popupManagerState/getLengthOfPopupOrder'] === 0 ? _c('button', {
    staticClass: "mortgage-add-button",
    "class": _vm.classCst,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showMortgageAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.text ? _vm.title : '+ Vytvoriť hypotéku') + " ")]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }